import { render } from "./PaymentsDocumentsListStage.vue?vue&type=template&id=3e51358a&scoped=true"
import script from "./PaymentsDocumentsListStage.vue?vue&type=script&lang=js"
export * from "./PaymentsDocumentsListStage.vue?vue&type=script&lang=js"

import "./PaymentsDocumentsListStage.vue?vue&type=style&index=0&id=3e51358a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e51358a"]])

export default __exports__